{
  "EMOJI": {
    "PLACEHOLDER": "Hľadať emoji",
    "NOT_FOUND": "Žiadne emoji nezodpovedá vášmu hľadaniu",
    "REMOVE": "Odstrániť"
  }
}
